/**
 * @internal
 */
export class PathConstraintData {

	name: string;
	bones: number[] = [];
	target: string;
	positionMode: string;
	spacingMode: string;
	rotateMode: string;
	offsetRotation: number;
	position: number;
	spacing: number;
	rotateMix: number;
	translateMix: number;

	constructor() {

	}
}

